import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Container} from 'reactstrap';
import {isBrowser, isMobile} from 'react-device-detect';
import SubscriberDetailsHeader from './SubscriberDetailsHeader';
import AbroadUsage from './AbroadUsage';
import AbroadCustomerExistingPackages from './AbroadCustomerExistingPackages';
import {
  setIsSelectingAccountBusinessIndividual,
  clearSearchParameters,
} from '../cellcomAbroadBlockSlice';
import { getUsageData } from '../Shared/abroadThunk';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import gaParams from '../../../../utilities/analytics/constants';
import StickyFooter from './StickyFooter';
import {getReportParams, report} from '../../../../middleware/report';
import {saveStateToHistory} from '../../../../utilities/stateUtils';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {objectIsEmpty} from '../../../../utilities/StringHelpers/StringHelpers';
import PlaneLoader from '../../AbroadTicketBlock/PlaneLoader';
import AbroadAdditionalServices from './AbroadAdditionalServices';

function PackageExistsMainComponent({
  // mobile,
  context,
  userUsageData,
  businessId,
  privateId,
  otpTicketId,
  customerAbroadPackages,
  epiStyleInitializationData,
  getUsageData,
  cellcomAbroad,
  isShowDataUsage,
  setIsSelectingAccountBusinessIndividual,
  validateExistedPackages,
  authentication,
  clearSearchParameters,
}) {
  useEffect(() => {
    gaEvent(
      gaParams.ABROAD_MY_ABROAD_ENTER_LOBBY.category,
      gaParams.ABROAD_MY_ABROAD_ENTER_LOBBY.eventType,
      gaParams.ABROAD_MY_ABROAD_ENTER_LOBBY.eventParams
    );

    let reportParams = {};
    reportParams = getReportParams();
    reportParams.area = 'SelfCare';
    reportParams.subArea = 'Cellcom Abroad';
    reportParams.channel = userUsageData?.userType == 'Private' ? 'WebsitePrivate' : 'WebsiteBusiness';
    reportParams.actionType = 'Enter Package Exists';
    reportParams.status = 'Completed';
    reportParams.messageText = 'Enter Package Exists';
    reportParams.param1 = 'WEBSITE';
    if (cellcomAbroad.isJETAuthentication) {
      reportParams.param1 = 'JET';
    }
    if (
      cellcomAbroad.otpData?.validatedCostumerData?.isSeparatedSale ||
      cellcomAbroad.userUsageData?.accountSegment?.toUpperCase() === 'CANTSALENOW'
    ) {
      reportParams.param3 = 'מכר בהפרדה';
    }
    if(authentication?.loginData?.userDetails){
      reportParams.idNumber = authentication.loginData.userDetails.IDNumber;
      reportParams.subscriber = authentication.loginData.userDetails.contactNumber;
   }
    report(reportParams);

    if (isBrowser) {
      window.scrollTo({
        top: 300,
        left: 0,
        behavior: 'smooth',
      });
    }

    return () => {};
  }, []);

  const changeAccountBusinessIndividual = () => {
    const params = {
      isSelecting: true,
      removeSelectedAbroadPackage: false,
    };
    clearSearchParameters();
    setIsSelectingAccountBusinessIndividual(params);
    context.navigateTo(cellcomAbroad.businessIndividualData.selfCareBlockUrl);
  };

  const showEmptySubscriberHeader = () => {
    if (
      !cellcomAbroad.epiStyleInitializationData.businessIndividualLobby &&
      (authentication?.loginData?.isFullAuthenticated || authentication?.loginData?.isOtpExtendedAuthenticated) &&
      cellcomAbroad.relatedPhoneNumbers?.length > 0 &&
      // !cellcomAbroad.relatedPhoneNumbers.includes(authentication.loginData.userDetails.contactNumber) &&
      !cellcomAbroad.relatedPhoneNumbers.includes(cellcomAbroad.otpData.otpPhone)
    ) {
      setImmediate(() => {
        document.getElementsByClassName('packageExists')[0]?.classList.remove('packageTabLoader', 'not-validated');
      });

      return true;
    }
    return false;
  };

  function render() {
    if ((objectIsEmpty(customerAbroadPackages) === true || objectIsEmpty(userUsageData) === true) && !showEmptySubscriberHeader()) {
      if (customerAbroadPackages?.errorCode == '99' || customerAbroadPackages == 'GeneralError' || customerAbroadPackages == 'error') {
        return (
          <div className='package-exists-root'>
            <SubscriberDetailsHeader
              isBusinessIndividual={cellcomAbroad.epiStyleInitializationData.businessIndividualLobby}
              isLoginAuthentication={authentication?.loginData?.isFullAuthenticated || authentication?.loginData?.isOtpExtendedAuthenticated}
              changeAccountBusinessIndividual={() => changeAccountBusinessIndividual()}
              validateExistedPackages={validateExistedPackages}
             />
          </div>
        );
      } else {
        return (
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            {!cellcomAbroad.generalLoader && <PlaneLoader />}
          </div>
        );
      }
    } else {
      return (
        <div className='package-exists-root'>
          <SubscriberDetailsHeader
            changeAccountBusinessIndividual={() => changeAccountBusinessIndividual()}
            isBusinessIndividual={cellcomAbroad.epiStyleInitializationData.businessIndividualLobby}
            validateExistedPackages={validateExistedPackages}
            relatedPhoneNumbers={cellcomAbroad.relatedPhoneNumbers}
            isLoginAuthentication={authentication?.loginData?.isFullAuthenticated || authentication?.loginData?.isOtpExtendedAuthenticated}
          />
          {!showEmptySubscriberHeader() && (
            <>
              {isShowDataUsage && <AbroadUsage context={context} userUsageData={userUsageData} />}

              <AbroadCustomerExistingPackages
                customerAbroadPackages={customerAbroadPackages}
                epiStyleInitializationData={epiStyleInitializationData}
                context={context}
              />
            </>
          )}
            <AbroadAdditionalServices context={context}/>
          <StickyFooter />
        </div>
      );
    }
  }

  return render();
}

const mapStateToProps = (state) => ({
  businessId: state.cellcomAbroad.epiStyleInitializationData.businessSocPackageFolderId,
  privateId: state.cellcomAbroad.epiStyleInitializationData.privateSocPackageFolderId,
  userUsageData: state.cellcomAbroad.userUsageData,
  customerAbroadPackages: state.cellcomAbroad.customerAbroadPackages,
  cellcomAbroad: state.cellcomAbroad,
  authentication: state.authentication,
});

const mapDispatchToProps = {
  getUsageData,
  setIsSelectingAccountBusinessIndividual,
  clearSearchParameters,
};

export default connect(mapStateToProps, mapDispatchToProps)(PackageExistsMainComponent);
